import { useTranslations } from 'next-intl';
import type { MatchCondition } from '../../types';

const getMatch = ({ numbers, extraNumbers }: MatchCondition['matches'], t: ReturnType<typeof useTranslations>) => {
  const extra = extraNumbers ?? 0;
  return t('results_match', {
    numbers,
    extraNumbers: extra,
    showPlus: numbers > 0 && extra > 0 ? 1 : 0,
  });
};

function useGetMatch(namespace: string) {
  const t = useTranslations(namespace);
  return (matches: MatchCondition['matches']) => getMatch(matches, t);
}

export { useGetMatch };
